/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import {
  CalendarOutlined,
} from '@ant-design/icons';

import blank from './blank';

export default {
  title: 'Catálogo de Citas',
  icon: () => <CalendarOutlined />,
  showInSidebar: true,
  type: 'private',
  children: [
    {
      title: 'Citas',
      icon: null,
      component: blank,
      type: 'private',
      showInSidebar: true,
    },
  ],

};
